import type { RouteObject } from 'react-router-dom'

import { route as auth0Route } from './auth0'
import { route as customRoute } from './custom'
import { route as fronteggRoute } from './frontegg'
import { route as fronteggCustomRoute } from './frontegg_custom'

export const route: RouteObject = {
	path: 'auth',
	children: [auth0Route, customRoute, fronteggRoute, fronteggCustomRoute],
}
